c<template lang="html">
  <v-layout row wrap >
    <v-flex xs12 class="setBgHeader widthfull" :style="{background: backgroudHeader}">
      <h3 class="centerDiv mt-1" style="color: white">แชทกับเรา</h3>
    </v-flex>
    <v-flex xs12 class="headername widthfull">
      <v-avatar class="f-l mr-2 user-photoprofilechat" >
        <img src="/static/img/call-center.png" alt="John" class="alligator-turtle">
      </v-avatar>
      <v-layout row wrap align-center style="padding-top: 12px;">
          <h4 style="margin-left: 1vw;">จบการสนทนา</h4>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="setHeightChatBoxrating" style="text-align: center;background: white;" v-if="tokenservice !== undefined && tokenservice !== null">
      <!-- <h4>คุณได้ให้คะแนน {{score}} คะแนน</h4> -->
      <br>
      <h3>ขอบคุณที่ใช้บริการค่ะ</h3>
      <br>
        <v-btn :style="{background: backgroudHeader}" :loading="loading" dark round @click="startchat()">เริ่มสนทนาใหม่</v-btn>
    </v-flex>
    <v-flex xs12 class="setHeightChatBoxrating" style="text-align: center;background: white;" v-else>
      <v-layout align-center justify-center column style="margin-top: 200px;">
        <h2>ขอบคุณที่ใช้บริการค่ะ</h2>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
const theme = require('../assets/theme')
export default {
  data () {
    return {
      theme,
      loading: false,
      hover: true,
      halfincrements: true,
      rating: 0,
      subject: '',
      header: '',
      body: '',
      tokenuser: '',
      tokenroom: '',
      tokenservice: '',
      // servicename: '',
      backgroudHeader: '',
      // keyservice: '',
      score: ''
    }
  },
  created () {
    this.subject = localStorage.getItem('subject')
    this.tokenroom = this.$route.params.tokenroom
    this.tokenuser = localStorage.getItem('tokenuser')
    this.tokenservice = this.$session.get('tokenservice')
    // console.log(this.tokenservice)
    this.score = localStorage.getItem('score')
    var servicename = this.$route.params.servicename
    if (this.theme[servicename].servicename === this.$route.params.servicename) {
      this.backgroudHeader = this.theme[servicename].background
    } else {
      this.backgroudHeader = '#01579b'
    }
    if (this.tokenservice === null) {
      localStorage.clear()
    }
  },
  watch: {
    '$route.params.tokenroom' () {
      this.tokenroom = this.$route.params.tokenroom
    }
  },
  methods: {
    startchat () {
      this.loading = true
      var servicename = this.$route.params.servicename
      if (this.theme[servicename].servicename === this.$route.params.servicename) {
        // console.log('1')
        localStorage.clear()
        this.$router.push({path: '/register/' + this.theme[servicename].servicename + '/' + this.theme[servicename].authen, force: true})
        this.loading = false
      } else {
        // console.log('2')
      }
    }
  }
}
</script>

<style lang="css" scoped>
.headername {
  background-color: #424242;
  height: 50px;
  color: #E0E0E0;
  margin-top: -2px;
  /*margin-bottom: 1vh;*/
  /*position: fixed;*/
  /*width: 100%;*/
  /*margin-top:30px;*/
}
.setHeightChatBoxrating {
  height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  /*overflow-y: scroll;*/
  padding-top: 5px;
}
.setBgHeader {
  background-color: #01579B;
  height: 30px;
  border-top-left-radius: 10px; 
  border-top-right-radius: 10px;
}
.chatBoxFriend {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #E0E0E0;
  padding: 12px;
}
.chatBox {
  word-wrap: break-word;
  max-width: 50%;
  border-radius: 25px;
  background: #B3E5FC;
  color: black;
  padding: 12px;
}

textarea:focus{
  outline: none !important;
  box-sizing: border-box !important;
  resize: none;
}
.textBox{
  height: 50px;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: rgb(101,101,101);
}

.colorFooterMenu {
  color: #424242
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.user-photoprofilechat{
  background-color: white;
  width: 35px !important;
  height: 35px !important;
  border-radius: 50%;
  overflow: hidden;
  margin: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Endchatpage.vue